(() => {
  function recenterIfNeeded(swiper, section, realSlideCount) {
    if (!swiper || !realSlideCount) return;
    const activeIndex = swiper.activeIndex;

    if (activeIndex < realSlideCount) {
      swiper.slideTo(activeIndex + realSlideCount, 0, false);
    } else if (activeIndex >= realSlideCount * 2) {
      swiper.slideTo(activeIndex - realSlideCount, 0, false);
    }

    updateActiveDescription(swiper, section);
  }

  function updateActiveDescription(swiper, section) {
    const target = section.querySelector('[data-sunster-rvac-benefits-description]');
    if (!target || !swiper.slides || !swiper.slides.length) return;
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    target.innerHTML = activeSlide.dataset.description || '';
    target.style.setProperty(
      '--sunster-rvac-benefits-description-color',
      activeSlide.dataset.descriptionColor || '#111111'
    );
  }

  function initBenefitsSection(section) {
    if (!section || section.dataset.swiperReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const container = section.querySelector('.sunster-rvac-benefits__swiper');
    const nextEl = section.querySelector('.sunster-rvac-benefits__nav--next');
    const prevEl = section.querySelector('.sunster-rvac-benefits__nav--prev');
    if (!container || !nextEl || !prevEl) return;

    const realSlideCount = Number(section.dataset.realSlides || 0);
    const slideCount = container.querySelectorAll('.swiper-slide').length;
    if (!realSlideCount || !slideCount) return;

    const initialRealIndex = Math.min(2, Math.max(0, realSlideCount - 1));
    const initialSlide = realSlideCount + initialRealIndex;

    const swiper = new Swiper(container, {
      centeredSlides: true,
      initialSlide,
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 36,
      speed: 600,
      navigation: {
        nextEl,
        prevEl,
      },
      on: {
        init(instance) {
          recenterIfNeeded(instance, section, realSlideCount);
        },
        slideChangeTransitionEnd(instance) {
          recenterIfNeeded(instance, section, realSlideCount);
        },
      },
      breakpoints: {
        0: {
          spaceBetween: 18,
        },
        750: {
          spaceBetween: 36,
        },
      },
    });

    section.dataset.swiperReady = 'true';
    section.swiper = swiper;
  }

  function initBenefits(root = document) {
    root.querySelectorAll('[data-sunster-rvac-benefits]').forEach(initBenefitsSection);
  }

  document.addEventListener('DOMContentLoaded', () => initBenefits());
  document.addEventListener('shopify:section:load', (event) => initBenefits(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sunster-rvac-benefits]').forEach((section) => {
      if (section.swiper) {
        section.swiper.destroy(true, true);
      }
      delete section.swiper;
      delete section.dataset.swiperReady;
    });
  });
})();
